import { useSelector } from 'react-redux'
import { OraclePriceState, State } from '../types'

export const usePriceData = (): OraclePriceState => {
  return useSelector((state: State) => state.oracle)
}
